<script>
import ProductListOrder from "@/components/ordering/summary/ProductListOrder.vue";
import {api} from "@/modules/api";

export default {
  name: 'SummaryPanel',
  components: {ProductListOrder},
  data () {
    return {
      deliveryAddress: this.$route.query.deliveryAddress,
      address: {}
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    getAddress () {
      return `${this.address.users.lastname} ${this.address.users.firstname} - ${this.address.numberRoute} ${this.address.route}, ${this.address.zipcode} ${this.address.city}, ${this.address.country}`
    }
  },
  methods: {
    loadData () {
      api.address.getById(this.deliveryAddress).then((res) => {
        this.address = res
      })
    }
  }
}
</script>

<template>
      <div class="space-y-4">
        <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Votre récapitualtif</h2>

        <div class="mt-6 space-y-4 border-b border-t border-gray-200 py-8 dark:border-gray-700 sm:mt-8">
          <h4 class="text-lg font-semibold text-gray-900 dark:text-white">Adresse de facturation et livraison</h4>

          <dl>
            <dd v-if="address.users" class="mt-1 text-base font-normal text-gray-500 dark:text-gray-400">
              {{ getAddress }}
            </dd>
          </dl>

          <router-link :to="{name: 'order_checkout'}" class="text-base font-medium text-primary-700 hover:underline dark:text-primary-500">
            modifier
          </router-link>
        </div>

        <div class="mt-6 sm:mt-8">
          <div class="relative overflow-x-auto border-b border-gray-200 dark:border-gray-800">
            <product-list-order />
          </div>
        </div>
      </div>
</template>
